<template>
  <div>
    Sliders Page
  </div>
</template>

<script>
export default {
  name: 'Sliders',
  created () {

  }
}
</script>



// WEBPACK FOOTER //
// Sliders.vue?e7e53cd6